ph<template>
<div>
    <div class="form-container ou-donation-form">
        <div class="holder">
            <PaymentForm class="form-horizontal">                                             
                <FormSection title="Your Details">
                    <FormRow inline>      
                        <FormCol field="title" :flex="1" />
                        <FormCol field="firstName" :flex="2" />
                        <FormCol field="lastName" :flex="2" />
                    </FormRow>
                    <FormRow inline>
                        <FormCol field="email" />
                    </FormRow>
                    <FormRow>
                        <FormCol field="phone" />    
                        <div class="note">
                            If possible, please share a number that can receive WhatsApp messages, should we have to reach you on the day of the trip.  
                        </div>   
                    </FormRow>
                    <FormRow inline>
                      <Consent privacy="https://www.ou.org/privacy-policy/"/>
                  </FormRow>                      
                </FormSection>
                    
                <FormSection title="Billing Information" >
                    <DonorAddress />
                </FormSection>

                <FormSection>
                    <FormRow>
                      <NewsletterSubscribe text="Please click here to receive important tour information" />
                    </FormRow> 
                    <FormRow>
                        <label class="control-label"
                        ><input
                            type="checkbox"
                            :checked="getValue('custom.AttendInPerson')"
                            @click="setValue('custom.AttendInPerson', $event.target.checked)"
                        />
                        Please reserve my spot. I look forward to joining you on Friday morning, January 20, 2023.</label
                        >
                    </FormRow>
                    <ErrorLabel field="custom.AttendInPerson" customError="Please check the reservation"/>
                </FormSection>  

                <FormSection title="Media Release Form">
                    <MediaRelease />            
                </FormSection>
                <FormSection title="Payment">                    
                    <FormRow>
                        <LazyCurrencySelector :currencies="['ILS', 'USD']" style="max-width: 180px;"/>
                        <div style="margin-left: 20px">
                            <b>Price: </b> <span class="currency-symbol" v-html="form.currency == 'ILS' ? '₪' : '$'"></span> {{form.amount}}
                        </div>
                    </FormRow>
                    <FormRow inline>
                        <FormCol field="card" :showLabel="false" />
                    </FormRow>
                    <FormRow>
                        <PaymentButton showAmount btnText="Submit"/>
                    </FormRow>
                </FormSection>                             
            </PaymentForm>
        </div>
    </div>
</div>
</template>
<script lang="ts">
import { defineComponent, onMounted, ref, watch, computed } from 'vue'
import { usePaymentForm } from '~/shared/use-payment-form'

export default defineComponent({
  setup() {
    const { form, setValue, getValue } = usePaymentForm()

    const currency = ref(form.value.currency)

    onMounted(() => {
        setValue('amount', '75')
    })

    watch(() => getValue('currency'), () => {
      if (getValue('currency') == 'ILS') {
        setValue('amount', '75')
      }
      else if(getValue('currency') == 'USD'){
        setValue('amount', '25')
      }
    })

    return {
      form,
      currency,
      setValue,
      getValue
    }
  },
})
</script>
<style scoped lang="scss">
.form-container.ou-donation-form{
    margin: 0;
    padding: 0;
    box-shadow: none;
}
h2.payment-heading {
  display: flex;
  justify-content: space-between;
}
.note {
    font-size: 14px;
    margin-left: 20px;
    max-width: 400px;
    margin-top: 15px;
}
.control-label {
    font-size: 14px;
    color: #222;
    padding-top: 3px;
    padding-bottom: 3px;
    display: block;
}
</style>

